import { AccountInjuryIcon } from './AccountInjuryIcon';

/**
 * author: Google
 * id E2BDD02C-EBDD-4394-9C2B-20279DBDF180
 * name account-injury
 * version: 6.1.95
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/account-injury.svg
 * tags
 * - Medical / Hospital 
 * - Account / User 
 */
export const PatientIcon = AccountInjuryIcon;
export default PatientIcon